var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.5,
    width: 16,
    height: 11,
    rx: 1.5,
    fill: "white",
    stroke: "#747BA0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.5H16.5V14C16.5 14.8284 15.8284 15.5 15 15.5H2C1.17157 15.5 0.5 14.8284 0.5 14V4.5Z",
    fill: "white",
    stroke: "#747BA0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 3,
    height: 3,
    fill: "#747BA0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11,
    width: 3,
    height: 3,
    fill: "#747BA0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6,
    width: 3,
    height: 3,
    fill: "#747BA0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11,
    width: 3,
    height: 3,
    fill: "#747BA0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 3,
    height: 3,
    fill: "#747BA0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 3,
    height: 3,
    fill: "#747BA0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 0.5,
    x2: 4.5,
    y2: 2.5,
    stroke: "#747BA0",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 0.5,
    x2: 12.5,
    y2: 2.5,
    stroke: "#747BA0",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date-icon.8ed0e6c6a42b30b13566f3305c2d98c6.svg";
export { ForwardRef as ReactComponent };